export default __webpack_public_path__ + "static/media/TimerIcon.10acd789.svg";